<div class="filter-container">
    <div class="date-filter">
        <input type="text" class="range-picker-input" bsDaterangepicker [bsValue]="rangeValue"
            [bsConfig]="rangeDateConfig" (bsValueChange)="onDateRangeChange($event)"
            placeholder="Selecciona un rango" />
    </div>
    <div class="filter-item">
        <app-filter-object-option-select [BindId]="'ProductKey'" [BindName]="'ProductName'" [Options]="productsArray"
            [PlaceholderFilter]="('FILTER_PRODUCTS' | translate)" [SelectedText]="('FILTER_PRODUCTS' | translate)"
            [NoOptionsText]="('ROLE_FILTER.no_options' | translate)" [SelectedOptions]="selectedProducts" [IconUrl]="''"
            [Multiselect]="true" [zIndex]="1001"
            (filterValueEmitter)="onProductChange($event)"></app-filter-object-option-select>
    </div>
    <div class="filter-item">
        <app-filter-object-option-select [BindId]="'id'" [BindName]="'name'" [Options]="serviceStatusArray"
            [PlaceholderFilter]="('FILTER_STATUS_PLACEHOLDER' | translate)"
            [SelectedText]="('FILTER_STATUS' | translate)" [NoOptionsText]="('ROLE_FILTER.no_options' | translate)"
            [SelectedOptions]="selectedStatus" [IconUrl]="''" [Multiselect]="true" [zIndex]="1001"
            (filterValueEmitter)="onStatusChange($event)"></app-filter-object-option-select>
    </div>
</div>